module.exports = __webpack_public_path__ + "img/la.000f7e98.svg";